import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, X } from 'lucide-react';
interface Sale {
  name: string;
  location: string;
}
const sales: Sale[] = [{
  name: 'James',
  location: 'London, UK'
}, {
  name: 'Michael',
  location: 'Manchester, UK'
}, {
  name: 'David',
  location: 'Dublin, Ireland'
}, {
  name: 'Chris',
  location: 'Toronto, Canada'
}, {
  name: 'Ryan',
  location: 'Sydney, Australia'
}, {
  name: 'Daniel',
  location: 'New York, USA'
}, {
  name: 'Mark',
  location: 'Los Angeles, USA'
}, {
  name: 'Liam',
  location: 'Glasgow, UK'
}, {
  name: 'Ethan',
  location: 'Auckland, New Zealand'
}, {
  name: 'Jack',
  location: 'Chicago, USA'
}, {
  name: 'Oliver',
  location: 'Birmingham, UK'
}, {
  name: 'Noah',
  location: 'Melbourne, Australia'
}, {
  name: 'Lucas',
  location: 'Vancouver, Canada'
}, {
  name: 'Harry',
  location: 'Leeds, UK'
}, {
  name: 'Connor',
  location: 'Boston, USA'
}];
const VISIBLE_MS = 5000;
const HIDDEN_MS = 8000;
export function SalesNotification() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(3);
  const showNext = useCallback(() => {
    setIndex(prev => (prev + 1) % sales.length);
    setMinutesAgo(Math.floor(Math.random() * 12) + 1);
    setVisible(true);
  }, []);
  useEffect(() => {
    // First popup after a short delay
    const initial = setTimeout(showNext, 4000);
    return () => clearTimeout(initial);
  }, [showNext]);
  useEffect(() => {
    if (!visible) return;
    const hide = setTimeout(() => setVisible(false), VISIBLE_MS);
    return () => clearTimeout(hide);
  }, [visible]);
  useEffect(() => {
    if (visible) return;
    const next = setTimeout(showNext, HIDDEN_MS);
    return () => clearTimeout(next);
  }, [visible, showNext]);
  const sale = sales[index];
  return <div className="fixed bottom-4 left-4 z-50 pointer-events-none" aria-live="polite" data-id="element-163">
      <AnimatePresence data-id="element-164">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.9
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 30,
        scale: 0.9
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="pointer-events-auto flex items-center gap-3 bg-navy-900 border border-navy-700 rounded-xl shadow-2xl p-3 pr-9 max-w-[300px] relative" data-id="element-165">
            <button onClick={() => setVisible(false)} aria-label="Dismiss notification" className="absolute top-2 right-2 text-gray-500 hover:text-gray-300 transition-colors focus:outline-none" data-id="element-166">
              <X className="w-4 h-4" data-id="element-167" />
            </button>

            <div className="flex-shrink-0 w-10 h-10 rounded-full bg-green-500/15 flex items-center justify-center" data-id="element-168">
              <CheckCircle className="w-6 h-6 text-green-500" data-id="element-169" />
            </div>

            <div className="min-w-0" data-id="element-170">
              <p className="text-sm text-white font-medium leading-tight" data-id="element-171">
                <span className="font-bold" data-id="element-172">{sale.name}</span> from{' '}
                <span className="text-gold-400" data-id="element-173">{sale.location}</span>
              </p>
              <p className="text-xs text-gray-400 leading-tight mt-0.5" data-id="element-174">
                just purchased Football Ready: System 365
              </p>
              <p className="text-[11px] text-gray-500 mt-1 flex items-center gap-1" data-id="element-175">
                <span className="w-1.5 h-1.5 rounded-full bg-green-500 inline-block" data-id="element-176"></span>
                {minutesAgo} minute{minutesAgo === 1 ? '' : 's'} ago · Verified
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}